import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(actionsStyles, {
    ...actionsStyles,
    price: {
        quoteMessageWrapper: {
            css: css`
                &.grid {
                    text-align: left;
                }
                text-align: right;
            `,
        },
        quoteMessage: {
            text: {
                size: 11.2,
                fontFamily: "OpenSansBold",
                css: css`
                    margin-right: 5px;
                `,
            },
            tooltip: {
                iconProps: {
                    size: 14,
                    css: css`
                        transform: translateY(3px);
                        svg {
                            stroke: #fff;
                            fill: ${getColor("text.main")};
                            :hover {
                                fill: ${getColor("primary")};
                            }
                        }
                    `,
                },
            },
        },
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                label {
                    display: none;
                }
                margin-right: 10px;
                width: 4.1rem;
                min-width: 4.1rem;
            `,
            inputSelect: css`
                border: 1px solid ${CarotekColors.grey10} !important;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 10px;
            gap: 10px;
        `,
    },
    addToCartButton: {
        variant: "primary",
        typographyProps: {
            size: 14,
        },
        css: css`
            width: 100%;
            padding-top: 0.6rem;
            padding-right: 0.7rem;
            padding-bottom: 0.65rem;
            padding-left: 0.7rem;
            margin: 0 0 0.5rem;
            span {
                line-height: 17px;
                font-family: "OpenSansBold";
            }
            :hover {
                background-color: ${getColor("danger")};
                border-color: ${getColor("danger")};
                span {
                    color: #fff;
                }
            }
        `,
    },
});
